import { BaseSelect } from '@app/components';
import { kitchenAreaApi } from '@app/store';
import { createColumnHelper } from '@tanstack/react-table';
import { IKitchenArea } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectParentProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<IKitchenArea>();

export const KitchenAreaSelect = ({ label = 'Lieux de fabrication', ...props }: ResourceSelectParentProps<IKitchenArea>) => {
  const columns = [
    columnHelper.accessor('name', {
      header: () => (
        <BaseSelect.ListHeaderItem width="50%">
          Nom
        </BaseSelect.ListHeaderItem>
      ),
      cell: (info) => (
        <BaseSelect.ListItemCol width="50%">
          <BaseSelect.ListItemText numberOfLines={1} bold>
            {info.getValue()}
          </BaseSelect.ListItemText>
        </BaseSelect.ListItemCol>
      ),
    }),
  ];

  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={kitchenAreaApi.useReadManyKitchenAreasQuery}
      {...props}
    />
  );
};
